import React from "react";
import { Field } from "formik";
import IField from "../../../../interfaces/field";
import Switch from "../../../switch";
import TplGroup from "../tpl-group";

type IProps = any & IField;

const InputSwitch: React.FC<IProps> = ({
  title,
  required = false,
  name,
  prefixName = "",
  ...el
}: IProps) => {
  const handleChange = (value: boolean): void => {
    if (el.setFieldValue) {
      el.setFieldValue(`${prefixName}${name}`, !value);
    }
  };

  return (
    <TplGroup
      name={`${prefixName}${name}`}
      prefixName={prefixName}
      title={title}
      required={required}
      {...el}
    >
      <Field name={`${prefixName}${name}`}>
        {({ field }: any) => (
          <Switch
            value={field.value}
            onClick={() => handleChange(field.value)}
          />
        )}
      </Field>
    </TplGroup>
  );
};

export default InputSwitch;
